import React from "react";
import { Link } from "react-router-dom";
import { SITE_URL } from "@/components/Seo";

export function Breadcrumbs({ items }) {
  return (
    <nav aria-label="Breadcrumb" className="text-sm text-slate-500 mb-4" data-testid="breadcrumbs">
      <ol className="flex flex-wrap items-center gap-1.5">
        {items.map((it, i) => (
          <li key={i} className="flex items-center gap-1.5">
            {it.to ? (
              <Link to={it.to} className="hover:text-emerald-700 transition-colors">{it.name}</Link>
            ) : (
              <span className="text-slate-700 font-medium truncate max-w-[220px]">{it.name}</span>
            )}
            {i < items.length - 1 && <span className="text-slate-300">/</span>}
          </li>
        ))}
      </ol>
    </nav>
  );
}

export function crumbLd(items) {
  return {
    "@context": "https://schema.org",
    "@type": "BreadcrumbList",
    itemListElement: items.map((it, i) => ({
      "@type": "ListItem",
      position: i + 1,
      name: it.name,
      item: SITE_URL + (it.to || "/"),
    })),
  };
}
